import React, { useEffect, useState, useRef } from "react";
import { Formik } from "formik";
import { Button, Col, Modal, Row } from "react-bootstrap";
import * as yup from "yup";
import Form from "react-bootstrap/Form";
import { useToasts } from "react-toast-notifications";
import CustomInput from "../../views/ui-elements/input/CustomInput";
import CustomSelect from "../../views/ui-elements/input/CustomSelect";
import CustomButtons from "../../views/ui-elements/Buttons/CustomButtons";
import CustomDangerButton from "../../views/ui-elements/Buttons/CustomDangerButton";
import { reset } from "redux-form";
import Patients from "../../modules/Patients";
import { ImCross } from "react-icons/im";
import { DatePicker } from "antd";
import moment from "moment";
import LdcApi from "../../LdcApis";
import { BsFillCloudUploadFill } from "react-icons/bs";
import dayjs from "dayjs";
import { Spin } from 'antd';

const validationSchema = yup.object().shape({
  patientName: yup.string().nullable().required("Field is required"),
  jobDetails: yup.string().required("Field is required"),
  priority: yup.string().required("Field is required"),
  // outComes: yup.string().optional('Field is required'),
  doctorId: yup.string().required("Field To is required."),
  category: yup.string().required("Field is required ."),
  assignedTo: yup.string().required("Field is required Assigned."),
  status: yup.string().required("Field is required"),
});
const priorityData = [
  { id: "Routine", name: "Routine" },
  { id: "Urgent", name: "Urgent" },
];

const statusData = [
  { id: "Open", name: "Open" },
  { id: "Completed", name: "Completed" },
];

const category = [
  { id: "Scripts", name: "Scripts" },
  { id: "Letters", name: "Letters" },
  { id: "Advice", name: "Advice" },
  { id: "Results", name: "Results" },
  { id: "Complaints", name: "Complaints" },
];

const departmentData = [
  { id: "Dermatology", name: "Dermatology" },
  { id: "Surgery", name: "Surgery" },
];

function EditPatientJobDialog({
  assignedData,
  editJobData,
  showEditJobPatient,
  handleClose,
  getJobDetailsPatient,
  getCaegoryListStatus,
  getRoleListStatus,
  loadingForDelete,
  setLoadingForDelete,
  roleListStatus,
}) {
  const photoUploadRef = useRef(null);
  const [previousPhoto, setPreviousPhoto] = useState(null);
  const [selectedPhotoFile, setSelectedPhotoFile] = useState([]);
  const [uploadPhotoError, setUploadPhotoError] = useState(false);
  const { addToast } = useToasts();
  const [dueDate, setDueDate] = useState(null);
  const [deuDateError, setDueDateError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [deleteTaskModal, setDeleteTaskModal] = useState(false);
  const [selectDocument, setSelectDocument] = useState("");
  // const [selectDocumentError, setSelectDocumentError] = useState(false);
  const [documentTabData, setDocumentTabData] = useState([]);
  const [alreadySelectedFile, setAlreadySelectedFile] = useState([]);
  const [showOtherField, setShowOtherField] = useState(false);
  const users = JSON.parse(localStorage.getItem("user_info"));
  const [doctorIdChanged, setDoctorIdChanged] = useState(false);
   const [isDocument, setIsDocument] = useState(true);
    const [isPhoto, setIsPhoto] = useState(false);
      const [attachmentLoader, setAttachmentLoader] = useState(false);
    
  useEffect(() => {
    if (editJobData.getAllFile?.length > 0) {
      setAlreadySelectedFile([...editJobData.getAllFile]);
    } else {
      setAlreadySelectedFile([]);
    }
  }, [editJobData, showEditJobPatient]);

  useEffect(() => {
    if (!showEditJobPatient) {
      setDoctorIdChanged(false);
    }
  }, [showEditJobPatient]);
// Sync checkbox state from editJobData only once when modal opens
useEffect(() => {
  if (showEditJobPatient && editJobData.patientId) {
    const docFlag = !!editJobData.isDocument;
    const photoFlag = !!editJobData.isPhoto;

    setIsDocument(docFlag);
    setIsPhoto(photoFlag);

    // fetch immediately based on job data
    fetchDocumentsTabData(editJobData.patientId, docFlag, photoFlag);
  } else {
    setDocumentTabData([]);
    setSelectDocument("");
  }
}, [showEditJobPatient, editJobData]);

  const handleDocumentChange = () => {
  if (editJobData.patientId) {
    setIsDocument(true);
    setIsPhoto(false);
    fetchDocumentsTabData(editJobData.patientId, true, false);
  }
};

const handlePhotoChange = () => {
  if (editJobData.patientId) {
    setIsPhoto(true);
    setIsDocument(false);
    fetchDocumentsTabData(editJobData.patientId, false, true);
  }
};

  // const handleDocumentChange = () => {
  //   setIsDocument(true);
  //   setIsPhoto(false);

  //   if (editJobData.patientId) {
  //     const id = editJobData.patientId;

  //     fetchDocumentsTabData(id, true, false); // directly call with new state
  //   }
  // };

  // const handlePhotoChange = () => {
  //   setIsPhoto(true);
  //   setIsDocument(false);

  //   if (editJobData.patientId) {
  //     const id = editJobData.patientId;
  //     fetchDocumentsTabData(id, false, true); // directly call with new state
  //   }
  // };
const fetchDocumentsTabData = (id, isDocument = true, isPhoto = false) => {
  setAttachmentLoader(true);

  LdcApi({
    method: "GET",
    url: `Patients/GetPatientAttachmentsBypatientID?patientId=${id}&isDocument=${isDocument}&isPhoto=${isPhoto}`,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
    .then((response) => {
      if (response?.status === 200) {
        setAttachmentLoader(false);
        setDocumentTabData(response?.data);

        // select document if editing
        if (editJobData?.pAttachmentId) {
          setSelectDocument(editJobData.pAttachmentId);
        }
      }
    })
    .catch(() => setAttachmentLoader(false));
};

  // useEffect(() => {
  //   const fetchDocumentsTabData = (id) => {
  //     LdcApi({
  //       method: "GET",
  //       url: `Patients/GetPatientAttachmentsBypatientID?patientId=${id}`,
  //       headers: {
  //         "Content-Type": "multipart/form-data",
  //       },
  //     })
  //       .then((response) => {
  //         if (response?.status === 200) {
  //           setDocumentTabData(response?.data);
  //           setSelectDocument(editJobData.pAttachmentId);
  //         }
  //       })
  //       .catch((error) => {});
  //   };
  //   if (showEditJobPatient) {
  //     fetchDocumentsTabData(editJobData.patientId);
  //   } else {
  //     setDocumentTabData([]);
  //     // setSelectDocumentError(false);
  //     setSelectDocument("");
  //   }
  // }, [showEditJobPatient]);
  const saveEditPatient = (values) => {
    // console.log("Hello");
    if (values.outComes1 === undefined) {
      values.outComes1 = "";
    }
    let editData = {
      patientName: values.patientName,
      jobDetails: values.jobDetails,
      outComes: values.outComes1,
      assignedTo: values.assignedTo,
      patientId: values.patientId,
      priority: values.priority,
      status: values.status,
      id: values.id,
      category: values.category,
      doctorId: values.doctorId,
    };
    const formData = new FormData();
    let doctorIdToSend = values.doctorId;

    // If D user & they never changed → force "Booking Team"
    if (users.userType === "D" && !doctorIdChanged) {
      doctorIdToSend = "Booking Team";
    }

    formData.append("doctorId", doctorIdToSend);

    formData.append("patientName", values.patientName);
    formData.append("jobDetails", values.jobDetails);
    formData.append("outComes", values.outComes1);
    formData.append("assignedTo", values.assignedTo);
    formData.append("patientId", values.patientId);
    formData.append("priority", values.priority);
    formData.append("status", values.status);
    formData.append("id", values.id);
    formData.append("category", values.category);
       formData.append('isDocument', isDocument);
    formData.append('isPhoto', isPhoto);
    // formData.append("doctorId", values.doctorId);
    formData.append("doctorId", doctorIdToSend);

    formData.append("getAllFile", alreadySelectedFile);
    selectedPhotoFile.forEach((file) => {
      formData.append("file", file);
    });

    if (dueDate) {
      const originalDate = new Date(dueDate["$d"]);
      const formattedDate = originalDate.toISOString();
      formData.append("dueDate", formattedDate);
    } else {
      setDueDateError(true);
    }
    // if(selectDocument){
    if (selectDocument === null) formData.append("PAttachmentId", "");
    else formData.append("PAttachmentId", selectDocument);
    // }else{
    // setSelectDocumentError(true);
    // }

    if (dueDate) {
      setLoading(true);
      Patients.addJobsPatients(formData, (response) => {
        if (response?.status === "success") {
          addToast("Task updated successfully.", { appearance: "success" });
          handleClose();
          getJobDetailsPatient();
          getCaegoryListStatus();
          getRoleListStatus();
          setDueDate(null);
          setDueDateError(false);
          photoUploadRef.current.value = null;
          setSelectedPhotoFile([]);
          setLoading(false);
          setSelectDocument("");
          setDocumentTabData([]);
          setAlreadySelectedFile([]);
          // setSelectDocumentError(false);
        } else {
          // addToast('Error Occured while Editing Task', { appearance: 'error' });
          setLoading(false);
        }
      });
    }
  };

  let formattedDate, formattedTime;
  if (editJobData.createdOn) {
    const [date, time] = editJobData.createdOn?.split("T");
    const [year, month, day] = date?.split("-");
    formattedDate = `${day}/${month}/${year.substring(2, year.length)}`;
    formattedTime = time?.slice(0, 5);
  }

  const fetchImageAsBlob = async (imageUrl) => {
    const response = await fetch(imageUrl);
    const blob = await response.blob();
    return blob;
  };
  useEffect(() => {
    const handlePhotoForFile = async () => {
      const blob = await fetchImageAsBlob(editJobData.filePath);
      const file = new File([blob], "image.png", { type: blob.type });
      setPreviousPhoto(file);
    };
    const handleDate = () => {
      if (editJobData.duedate) {
        const dateObject = new Date(editJobData.duedate);
        const momentDate = dayjs(dateObject);
        setDueDate(momentDate);
      } else {
        setDueDate(null);
      }
    };
    if (showEditJobPatient) {
      handlePhotoForFile();
      handleDate();
    }
  }, [editJobData, showEditJobPatient]);
  // useEffect(()=>{
  // },[selectedPhotoFile])
  const handlePhoto = (e) => {
    const newFiles = Array.from(e.target.files);
    if (newFiles) {
      setUploadPhotoError(false);
      setSelectedPhotoFile([...selectedPhotoFile, ...newFiles]);
    }
  };
  const handleDateChange = (date) => {
    if (date !== null) setDueDateError(false);
    if (date) {
      setDueDate(date);
    } else {
      setDueDate(null);
    }
  };
  const handleDeleteTask = () => {
    setDeleteTaskModal(true);
  };
  const completelyDeletedTask = (taskId) => {
    setLoadingForDelete(true);
    handleClose();
    Patients.deletePatientTask(taskId, (response) => {
      if (response?.status === "success") {
        closeDeleteTaskPopup();
        setLoadingForDelete(false);
        getJobDetailsPatient();
        getCaegoryListStatus();
        getRoleListStatus();
      } else {
        addToast("Doctor can not be deleted this task", {
          appearance: "error",
        });
      }
    });
  };
  const closeDeleteTaskPopup = () => {
    setDeleteTaskModal(false);
  };
  const closeEditPopUp = () => {
    setSelectedPhotoFile([]);
    if (photoUploadRef.current) photoUploadRef.current.value = null;
    setDueDateError(false);
    setDueDate(null);
    setSelectDocument("");
    setDocumentTabData([]);
    setAlreadySelectedFile([]);
    handleClose();
    setShowOtherField(false);
  };
  const handleCutButtonClick = (fileName) => {
    const updatedFiles = selectedPhotoFile.filter(
      (file) => file.name !== fileName
    );
    setSelectedPhotoFile(updatedFiles);
  };
  const handleCutButtonClickForPrev = (fileName) => {
    const updatedFiles = alreadySelectedFile.filter(
      (file) => file.fileName !== fileName
    );
    setAlreadySelectedFile(updatedFiles);
  };
  const handleButtonClick = () => {
    // Programmatically trigger a click event on the hidden file input
    photoUploadRef.current.click();
  };
  // console.log(editJobData)
  return (
    <div>
      <Modal
        size="xl"
        show={showEditJobPatient}
        onHide={() => {
          closeEditPopUp();
        }}
        className=""
        centered
        aria-labelledby="contained-modal-title-vcenter"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Edit Task(
            <span style={{ textTransform: "capitalize", fontSize: "20px" }}>
              Created By:{" "}
              {editJobData.cUser + ` ${formattedDate} ${formattedTime}`}
            </span>
            )
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="">
          {}
          <Formik
            initialValues={editJobData}
            validationSchema={validationSchema}
            onSubmit={saveEditPatient}
          >
            {({
              values,
              errors,
              resetForm,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
            }) => (
              <Form id="patientForm" onSubmit={handleSubmit}>
                <Row>
                  <Col md={12}>
                    <label>Patient</label>
                    <Form.Group className="mb-3" controlId="formBasicName">
                      <CustomInput
                        isDisabled={true}
                        type="text"
                        name="patientName"
                        value={values.patientName}
                        onChange={handleChange}
                        className="`form-control "
                        onBlur={handleBlur}
                        error={errors.patientName}
                        touched={touched.patientName}
                        // required
                      />
                      {touched.patientName && errors.patientName && (
                        <small className="text-danger error_field">
                          {errors.patientName}
                        </small>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <label>Task Details</label>
                    <Form.Group className="mb-3" controlId="formBasicName">
                      <textarea
                        cols="60"
                        rows="3"
                        name="jobDetails"
                        className="form-control"
                        placeholder="Task Details"
                        value={values.jobDetails}
                        onBlur={handleBlur}
                        error={errors.jobDetails}
                        touched={touched.jobDetails}
                        onChange={handleChange}
                        //style={{ width: '100%', marginTop: '-10px' }}
                        // required
                      />
                      {touched.jobDetails && errors.jobDetails && (
                        <small className="text-danger error_field">
                          {errors.jobDetails}
                        </small>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col lg={12} md={12}>
                    <label>Outcome</label>
                    <br />
                    {editJobData.outComes && (
                      <>
                        <label
                          style={{
                            whiteSpace: "normal",
                            wordWrap: "break-word",
                            width: "100%",
                          }}
                        >
                          {" "}
                          {`[${editJobData.cUser?.replace(
                            /\b\w/g,
                            function (match) {
                              return match.toUpperCase();
                            }
                          )} 
                         ${formattedDate} ${formattedTime}]`}{" "}
                          {editJobData.outComes.charAt(0).toUpperCase() +
                            editJobData.outComes.slice(1).toLowerCase()}
                        </label>
                        <br />
                      </>
                    )}
                    {editJobData.getJobListOutCome.map((item) => {
                      const [date, time] = item.modifiedOn.split("T");
                      const [year, month, day] = date.split("-");
                      const formattedDate = `${day}/${month}/${year.substring(2, year.length)}`;
                      const formattedTime = time.slice(0, 5);
                      return (
                        <>
                          <label
                            style={{
                              whiteSpace: "normal",
                              wordWrap: "break-word",
                              width: "100%",
                            }}
                          >
                            {`[${item.userName.replace(
                              /\b\w/g,
                              function (match) {
                                return match.toUpperCase();
                              }
                            )} ${formattedDate} ${formattedTime}]`}{" "}
                            {item.message.charAt(0).toUpperCase() +
                              item.message.slice(1).toLowerCase()}
                          </label>
                          <br />
                        </>
                      );
                    })}
                    <Form.Group className="mb-3" controlId="formBasicName">
                      <textarea
                        cols="60"
                        rows="3"
                        name="outComes1"
                        className="form-control"
                        placeholder=" Outcome"
                        // value={values.outComes1}
                        onBlur={handleBlur}
                        error={errors.outComes1}
                        touched={touched.outComes1}
                        onChange={handleChange}
                        //required
                        //style={{ width: '100%', marginTop: '-10px' }}
                      />
                      {touched.outComes && errors.outComes && (
                        <small className="text-danger error_field">
                          Field is required
                        </small>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
                {showOtherField && (
                  <Row>
                    <Col lg={6} md={6}>
                      <Row>
                        <Col md={12}>
                          <label>Priority</label>
                          <Form.Group
                            className="mb-3"
                            controlId="formBasicName"
                          >
                            <CustomSelect
                              defaultValue="Select priority"
                              //defaultValue=""
                              value={values.priority}
                              name="priority"
                              onChange={handleChange}
                              selectData={priorityData}
                              onBlur={handleBlur}
                              error={errors.priority}
                              touched={touched.priority}
                              // required
                            />
                            {touched.priority && errors.priority && (
                              <small className="text-danger error_field">
                                {errors.priority}
                              </small>
                            )}
                          </Form.Group>
                        </Col>

                        <Col md={6}>
                          <label>Category</label>
                          <Form.Group className="mb-3">
                            <CustomSelect
                              defaultValue="Select"
                              value={values.category}
                              name="category"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              style={{
                                borderColor: errors.category ? "red" : "",
                              }}
                              error={errors.category}
                              touched={touched.category}
                              // required
                              selectData={category}
                            />
                            {touched.category && errors.category && (
                              <small className="text-danger error_field">
                                Field is required.
                              </small>
                            )}
                          </Form.Group>
                        </Col>

                        <Col md={6}>
                          <label>Assigned To</label>
                          <Form.Group className="mb-3">
                            <CustomSelect
                              defaultValue="Select"
                              value={
                                users.userType === "D" && !doctorIdChanged
                                  ? "Booking Team"
                                  : values.doctorId
                              }
                              name="doctorId"
                              onChange={(e) => {
                                handleChange(e);
                                setDoctorIdChanged(true); // mark that user has changed it
                              }}
                              onBlur={handleBlur}
                              style={{
                                borderColor: errors.doctorId ? "red" : "",
                              }}
                              error={errors.doctorId}
                              touched={touched.doctorId}
                              selectData={assignedData}
                            />

                            {/* <CustomSelect
                              defaultValue="Select"
                              // value={
                              //   users.userType === "D"
                              //     ? "Booking Team"
                              //     : values.doctorId
                              // }
                              value={
                                users.userType === "D"
                                  ? values.doctorId &&
                                    values.doctorId !== "Booking Team"
                                    ? values.doctorId
                                    : "Booking Team"
                                  : values.doctorId
                              }
                              name="doctorId"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              style={{
                                borderColor: errors.doctorId ? "red" : "",
                              }}
                              error={errors.doctorId}
                              touched={touched.doctorId}
                              // required
                              selectData={assignedData}
                            /> */}
                            {touched.doctorId && errors.doctorId && (
                              <small className="text-danger error_field">
                                Field is required.
                              </small>
                            )}
                          </Form.Group>
                        </Col>

                        <Col md={6}>
                          <label>Due Date</label>
                          <Form.Group className="mb-3">
                            <DatePicker
                              value={dueDate}
                              onChange={handleDateChange}
                              format="DD/MM/YYYY"
                            />
                            {deuDateError && (
                              <small className="text-danger error_field">
                                Field is required.
                              </small>
                            )}
                          </Form.Group>
                        </Col>

                        <Col md={12}>
                                 <Form.Group
                      className='mb-0'
                      style={{ display: 'flex', alignItems: 'center' }}
                    >
                      <Form.Label
                        style={{ marginRight: '15px', minWidth: '120px' }}
                      >
                        Select Document : 
                      </Form.Label>

                     <label style={{ marginRight: '15px', display: 'flex', alignItems: 'center' }}>
                        <input
                          type='checkbox'
                          checked={isDocument}
                          onChange={handleDocumentChange}
                            style={{ marginRight: '5px' }}
                        />
                        Document
                      </label>

                     <label style={{ marginRight: '15px', display: 'flex', alignItems: 'center' }}>
                        <input
                          type='checkbox'
                          checked={isPhoto}
                          onChange={handlePhotoChange}
                            style={{ marginRight: '5px' }}
                        />
                        Photo
                      </label>
                    </Form.Group>
                          <Form.Group className="mb-3">
                            <CustomSelect
                              defaultValue={isDocument ? 'Select Document' : 'Select Photo'}
                              value={selectDocument}
                              name="selectDocument"
                              onChange={(e) => {
                                handleChange(e);
                                setSelectDocument(e.target.value);
                              }}
                              onBlur={handleBlur}
                              // style={{ borderColor: selectDocumentError ? 'red' : '' }}
                              // error={selectDocumentError}
                              touched={touched.selectDocument}
                              // required
                              selectData={documentTabData}
                            />
                               {attachmentLoader && (
                        <p
                          style={{
                            position: 'absolute',
                            top: '8px',
                            right: '30px',
                            marginBottom: '0px',
                          }}
                        >
                          <Spin />
                        </p>
                      )}
                            {/* {selectDocumentError && <small className="text-danger error_field">Field is required.</small>} */}
                          </Form.Group>
                        </Col>

                        {roleListStatus.length > 0 && (
                          <Col md={12}>
                            <label>Status</label>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicName"
                            >
                              <CustomSelect
                                defaultValue="Select status"
                                //defaultValue=""
                                value={values.status}
                                name="status"
                                onChange={handleChange}
                                selectData={statusData}
                                onBlur={handleBlur}
                                error={errors.status}
                                touched={touched.status}
                                required
                              />
                              {touched.status && errors.status && (
                                <small className="text-danger error_field">
                                  {errors.status}
                                </small>
                              )}
                            </Form.Group>
                          </Col>
                        )}
                      </Row>
                    </Col>
                    <Col lg={6} md={6}>
                      <Row>
                        <Col md={12}>
                          <label>Department</label>
                          <Form.Group
                            className="mb-3"
                            controlId="formBasicName"
                          >
                            <CustomSelect
                              defaultValue="Select"
                              value={values.assignedTo}
                              name="assignedTo"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              error={errors.assignedTo}
                              touched={touched.assignedTo}
                              // required
                              selectData={departmentData}
                            />
                            {touched.assignedTo && errors.assignedTo && (
                              <small className="text-danger error_field">
                                Field is required.
                              </small>
                            )}
                          </Form.Group>
                        </Col>
                        <Col md={12}>
                          <label htmlFor="uploadPhoto">Upload</label>
                          <label style={{ marginLeft: "15px" }}>
                            <BsFillCloudUploadFill
                              size={18}
                              onClick={handleButtonClick}
                              style={{ cursor: "pointer" }}
                            />
                          </label>
                          <Form.Group
                            className="mb-3"
                            style={{ width: "100%" }}
                          >
                            <div
                              className="form-control"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                gap: "20px",
                                height: "80px",
                                overflowY: "auto",
                              }}
                            >
                              <div
                                style={{
                                  width: "100%",
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: "10px",
                                }}
                              >
                                {selectedPhotoFile.map((file) => {
                                  return (
                                    <p
                                      key={file.name}
                                      style={{
                                        display: "flex",
                                        gap: "10px",
                                        alignItems: "center",
                                        border: "1px solid gray",
                                        background: "aliceblue",
                                        padding: "3px 10px",
                                        borderRadius: "3px",
                                        height: "max-content",
                                      }}
                                    >
                                      {file.name}
                                      {
                                        <ImCross
                                          size={12}
                                          style={{
                                            color: "red",
                                            cursor: "pointer",
                                          }}
                                          onClick={() =>
                                            handleCutButtonClick(file.name)
                                          }
                                        />
                                      }
                                    </p>
                                  );
                                })}
                              </div>
                              <input
                                type="file"
                                name="uploadPhoto"
                                className="form-control"
                                onChange={handlePhoto}
                                ref={photoUploadRef}
                                multiple
                                style={{ display: "none" }}
                              />
                            </div>
                          </Form.Group>
                        </Col>
                        {alreadySelectedFile.length > 0 && (
                          <Col lg={12} md={12}>
                            <label>Attached Documents</label>
                            <br />
                            {alreadySelectedFile.map((item) => {
                              const parts = item.fileName.split("_");
                              const filename = parts[parts.length - 1];
                              return (
                                <p
                                  key={item.fileName}
                                  style={{
                                    display: "flex",
                                    gap: "10px",
                                    alignItems: "center",
                                    border: "1px solid gray",
                                    background: "aliceblue",
                                    padding: "3px 10px",
                                    borderRadius: "3px",
                                    height: "max-content",
                                  }}
                                >
                                  {filename}
                                </p>
                              );
                            })}
                          </Col>
                        )}
                      </Row>
                    </Col>
                  </Row>
                )}
                {
                  <Button
                    onClick={() => {
                      setShowOtherField(!showOtherField);
                    }}
                  >
                    {showOtherField ? "Show Less" : "Show More"}
                  </Button>
                }
                {/* <div style={{display:"grid",gridTemplateColumns:"1fr 1fr"}}>
                  <div></div>
                </div> */}
                <div
                  className="my-4 mb-3 p-2 d-flex"
                  style={{ justifyContent: "space-between" }}
                >
                  <div style={{ display: "flex" }}>
                    <Button
                      disabled={loading}
                      type="submit"
                      variant={"outline-primary"}
                    >
                      {loading ? "Updating..." : "Update"}
                    </Button>
                    <CustomDangerButton
                      cancelOnClick={() => closeEditPopUp()}
                      variant="danger"
                      name="Cancel"
                    />
                  </div>
                  {roleListStatus.length > 0 && (
                    <button
                      className="btn btn-danger me-2"
                      type="button"
                      onClick={handleDeleteTask}
                    >
                      Delete
                    </button>
                  )}
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
      {editJobData && (
        <Modal
          size="xs"
          show={deleteTaskModal}
          onHide={closeDeleteTaskPopup}
          className="newModels"
          centered
          aria-labelledby="contained-modal-title-vcenter"
        >
          <Modal.Body className="">
            <div className="d-flex justify-content-between">
              <h4 className="text-secondary " style={{ fontWeight: "600" }}>
                WARNING!
              </h4>
            </div>
            <h6 className="mt-3">Are you sure you want to delete this task?</h6>
            <div className="d-flex mt-4 justify-content-around">
              <Button
                onClick={() => completelyDeletedTask(editJobData?.id)}
                className="px-5 "
                variant="success"
              >
                Yes
              </Button>
              <Button
                onClick={closeDeleteTaskPopup}
                className="px-5 "
                variant="danger"
              >
                No
              </Button>
            </div>
          </Modal.Body>
        </Modal>
      )}
      <Modal
        size="md"
        show={loadingForDelete}
        centered
        className="labloader_modal"
        style={{ zIndex: "9999" }}
      >
        <Modal.Body>
          <div className="spinner-container">
            <div className={`loading-spinner`}></div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default EditPatientJobDialog;
